import { CallOutAlertSize, CallOutAlertVariant, } from '../../../../../../components/callOutAlert/types/callOutAlertTheme';
import { TextVariantType } from '../../variants';
import { largeCommonStyles, mediumCommonStyles } from '../commonStyles';
export const getConversationalStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [CallOutAlertVariant.CONVERSATIONAL]: {
            [CallOutAlertSize.MEDIUM]: {
                ...mediumCommonStyles(FOUNDATIONS, FONT, SHADOWS),
                cardContainer: {
                    ...mediumCommonStyles(FOUNDATIONS, FONT, SHADOWS).cardContainer,
                    border_width: FOUNDATIONS.border_00,
                    box_shadow: SHADOWS.shadow_100,
                },
                description: {
                    ...mediumCommonStyles(FOUNDATIONS, FONT, SHADOWS).description,
                    font_variant: TextVariantType.FONT_TITLE_100,
                },
            },
            [CallOutAlertSize.LARGE]: {
                ...largeCommonStyles(FOUNDATIONS, FONT, SHADOWS),
                description: {
                    ...largeCommonStyles(FOUNDATIONS, FONT, SHADOWS).description,
                    font_variant: TextVariantType.FONT_TITLE_100,
                },
                cardContainer: {
                    ...largeCommonStyles(FOUNDATIONS, FONT, SHADOWS).cardContainer,
                    border_width: FOUNDATIONS.border_00,
                    box_shadow: SHADOWS.shadow_100,
                },
            },
        },
    };
};
//# sourceMappingURL=conversational.js.map